import useData from "../../../hooks/useData";
import {useEffect, useState} from "react";
import useAuth from "../../../hooks/useAuth";
import {useParams} from "react-router-dom";
import FormButtons from "../../../components/common/FormButtons";
import {getAgencyBillingInfos, updateAgencyBillingInfos} from "../../../api/admin/agencyReq";
import {
    checkRequiredFields,
    getErrorListFromValidation,
    removeErrorList,
    validateFormInput
} from "../../../helper/tools";
import Icon from "../../../components/common/Icon";

export default function FormAgencyBilling({ setShowModal, legend, apiAgencyBilling }) {

    const { auth } = useAuth();
    const token = auth.token;
    const { id } = useParams();
    const { billingAgencyList } = useData();
    const [ values, setValues ] = useState();
    const { agencyBilling } = useData();

    const handleRemoveModal = () => {
        setShowModal(false)
    };

     const handleSubmit = async (e) => {
        e.preventDefault()
         if (!checkRequiredFields()) {
             return;
         }
         let body = {
            id : id,
            billing : values?.billing || false,
            flateRate : values?.flateRate || false,
            templateOnline : values?.templateOnline || false,
            billingAgency : values?.billingAgency,
            hasBillingEmail : values?.hasBillingEmail || false,
            billingEmail : values?.billingEmail,
            invoiceNumber : values?.invoiceNumber,
            contractReference : values?.contractReference,
            deceasedNumber : parseInt(values?.deceasedNumber),
            templateNumber : parseInt(values?.templateNumber),
            deceasedPrice : parseFloat(values?.deceasedPrice),
            templatePrice : parseFloat(values?.templatePrice),
            deceasedReduct : values?.deceasedReduct,
            templateReduct : values?.templateReduct
         }
        await updateAgencyBillingInfos(token, body)
            .then(response => {
                removeErrorList()
                if(!response?.data?.data?.error) {
                    apiAgencyBilling()
                    setShowModal(false)
                } else {
                    getErrorListFromValidation(response?.data?.data?.error)
                }
            })
    }

    const onchange = (e) => {
        setValues({...values, [e.target.name] : e.target.value})
        if (e.target.type === "checkbox") {
            setValues({...values, [e.target.name] : e.target.checked})
        }
        validateFormInput(e);
    }

     useEffect(() => {
         if (agencyBilling) {
             setValues(agencyBilling)
         }
     }, [ agencyBilling ]);

    return (
        <form onSubmit={handleSubmit} method="post" noValidate>
            <fieldset>
                <Icon source="fa fa-file-invoice-dollar" span={legend}/>
                <div className="form-input">
                    <label>Facturation</label>
                    <input type="checkbox" name="billing" defaultChecked={values?.billing} onChange={onchange}/>
                </div>
                <div className="form-input">
                    <label>Au forfait</label>
                    <input type="checkbox" name="flateRate" defaultChecked={values?.flateRate} onChange={onchange}/>
                </div>
                <div className="form-input">
                    <label>Site partenaire</label>
                    <input type="checkbox" name="templateOnline" defaultChecked={values?.templateOnline} onChange={onchange}/>
                </div>
                <div className="form-input">
                    <label className="required">Agence de facturation</label>
                    <select name="billingAgency" value={values?.billingAgency} onChange={onchange} required>
                        <option name="billingAgency" value="" selected="selected" disabled="disabled">Sélectionnez une agence</option>
                        {billingAgencyList?.map(billingAgency => (
                            <option name="billingAgency" key={billingAgency?.id} value={billingAgency.id}>{billingAgency?.name}</option>
                        ))}
                    </select>
                </div>
                <div className="flex">
                    <div className="form-input">
                        <label htmlFor="hasBillingEmail">A une adresse mail de facturation</label>
                        <input name="hasBillingEmail" type="checkbox" defaultChecked={values?.hasBillingEmail} onChange={onchange}/>
                    </div>
                { values?.hasBillingEmail &&
                    <div className="form-input">
                        <label className="required">Adresse mail de facturation</label>
                        <input type="email" name="billingEmail" defaultValue={values?.billingEmail} onChange={onchange} required/>
                    </div>
                }
                </div>
                <div className="form-input">
                    <label className="required">Numéro de facture</label>
                    <input type="text" name="invoiceNumber" defaultValue={values?.invoiceNumber} onChange={onchange} required/>
                </div>
                <div className="form-input">
                    <label className="required">Référence contrat OEF</label>
                    <input type="text" name="contractReference" defaultValue={values?.contractReference} onChange={onchange}/>
                </div>
                <div className="form-input">
                    <label>Nombre de défunts</label>
                    <input type="number" name="deceasedNumber" defaultValue={values?.deceasedNumber} onChange={onchange} />
                </div>
                <div className="form-input">
                    <label>Nombre de sites</label>
                    <input type="number" name="templateNumber" defaultValue={values?.templateNumber} onChange={onchange} />
                </div>
                <div className="form-input">
                    <label>Prix défunt unitaire (H.T.)</label>
                    <input type="text" name="deceasedPrice" defaultValue={values?.deceasedPrice} onChange={onchange} />
                </div>
                <div className="form-input">
                    <label>Prix site unitaire (H.T.)</label>
                    <input type="text" name="templatePrice" defaultValue={values?.templatePrice} onChange={onchange} />
                </div>
                <div className="form-input">
                    <label>Réductions accordée pour les défunts (%)</label>
                    <input type="number" name="deceasedReduct" defaultValue={values?.deceasedReduct} onChange={onchange} />
                </div>
                <div className="form-input">
                    <label>Réduction accordée pour les sites (€)</label>
                    <input type="number" name="templateReduct" defaultValue={values?.templateReduct} onChange={onchange} />
                </div>
                <FormButtons handleRemoveModal={handleRemoveModal}/>
                <div className="errors"></div>
            </fieldset>
        </form>
    )
}

